var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 23.4,
    height: 27.4,
    rx: 3.2,
    fill: "none",
    stroke: "#00A2C7",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 7C5.7654 7 5.50045 7.10975 5.3051 7.3051C5.10975 7.50045 5 7.7654 5 8.04167C5 8.31793 5.10975 8.58289 5.3051 8.77824C5.50045 8.97359 5.7654 9.08333 6.04167 9.08333H18.5417C18.8179 9.08333 19.0829 8.97359 19.2782 8.77824C19.4736 8.58289 19.5833 8.31793 19.5833 8.04167C19.5833 7.7654 19.4736 7.50045 19.2782 7.3051C19.0829 7.10975 18.8179 7 18.5417 7H6.04167ZM5 12.2083C5 11.9321 5.10975 11.6671 5.3051 11.4718C5.50045 11.2764 5.7654 11.1667 6.04167 11.1667H18.5417C18.8179 11.1667 19.0829 11.2764 19.2782 11.4718C19.4736 11.6671 19.5833 11.9321 19.5833 12.2083C19.5833 12.4846 19.4736 12.7496 19.2782 12.9449C19.0829 13.1403 18.8179 13.25 18.5417 13.25H6.04167C5.7654 13.25 5.50045 13.1403 5.3051 12.9449C5.10975 12.7496 5 12.4846 5 12.2083ZM6.04167 15.3333C5.7654 15.3333 5.50045 15.4431 5.3051 15.6384C5.10975 15.8338 5 16.0987 5 16.375C5 16.6513 5.10975 16.9162 5.3051 17.1116C5.50045 17.3069 5.7654 17.4167 6.04167 17.4167H18.5417C18.8179 17.4167 19.0829 17.3069 19.2782 17.1116C19.4736 16.9162 19.5833 16.6513 19.5833 16.375C19.5833 16.0987 19.4736 15.8338 19.2782 15.6384C19.0829 15.4431 18.8179 15.3333 18.5417 15.3333H6.04167ZM6.04167 19.5C5.7654 19.5 5.50045 19.6097 5.3051 19.8051C5.10975 20.0004 5 20.2654 5 20.5417C5 20.8179 5.10975 21.0829 5.3051 21.2782C5.50045 21.4736 5.7654 21.5833 6.04167 21.5833H12.2917C12.5679 21.5833 12.8329 21.4736 13.0282 21.2782C13.2236 21.0829 13.3333 20.8179 13.3333 20.5417C13.3333 20.2654 13.2236 20.0004 13.0282 19.8051C12.8329 19.6097 12.5679 19.5 12.2917 19.5H6.04167Z",
    fill: "#00A2C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryInstructions);
export default __webpack_public_path__ + "static/media/delivery-instructions.e4814ab3d9d63bf401b8377587d78d71.svg";
export { ForwardRef as ReactComponent };